export default __webpack_public_path__ + "static/media/boca-delgada.e63015ec.png";